import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad4a66c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" We're sorry. We're having some technical difficulty submitting your request.")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "STSLandingGenericError_pls_try_again" }, "Please try again", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCustom = _resolveComponent("MessageCustom")!

  return (_ctx.errorMsgId)
    ? (_openBlock(), _createBlock(_component_MessageCustom, {
        key: _ctx.errorMsgId,
        "on-close": _ctx.storeErr
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }, 8, ["on-close"]))
    : _createCommentVNode("", true)
}